import {
  Box,
  Button,
  Link,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext, useEffect } from "react";
import { BannerCouponName, UpgradeDialogSource } from "schemas/dashboard";

import { useCheckout } from "components/StripeCheckout/useCheckout";

import BannerWrapper from "../BannerWrapper";
import { useCountDown } from "../useCountdown";

const NewSubscriberPromo = () => {
  const theme = useTheme();
  const { getPromoCodeByName } = useCheckout();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { setUpgradeDialogSource } = useContext(SubscriptionContext);
  const { display, createTimer } = useCountDown();
  const promoCode = getPromoCodeByName(BannerCouponName.new_subscriber);

  useEffect(() => {
    if (promoCode) {
      createTimer(promoCode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!promoCode) return <></>;

  return display ? (
    <BannerWrapper
      onClick={() =>
        setUpgradeDialogSource(UpgradeDialogSource.countdown_banner)
      }
    >
      <Box sx={{ py: 1 }}>
        <Typography
          sx={{ fontSize: { xs: 10, md: 14, color: "white" } }}
          textAlign="center"
        >
          Your exclusive {promoCode?.discountPercent}% discount{" "}
          {isMobileScreen ? "" : "on all plans"} expires in{" "}
          <strong>{display}</strong> ⏳
          {isMobileScreen && (
            <Link
              sx={{
                borderRadius: 1,
                ml: 1,
                backgroundColor: "white",
                color: "info.main",
                p: 0.5,
                fontWeight: 600,
                textDecoration: "none",
              }}
            >
              Upgrade{" "}
              <Box
                component="i"
                className="fa-regular fa-arrow-up-right-from-square"
              />
            </Link>
          )}
        </Typography>
      </Box>

      {!isMobileScreen && (
        <Button
          size="small"
          variant="contained"
          disableElevation
          sx={{
            backgroundColor: "white",
            color: "info.main",
            "&:hover": { backgroundColor: grey[100] },
            my: { xs: 1, md: 0 },
          }}
        >
          Upgrade Now{" "}
        </Button>
      )}
    </BannerWrapper>
  ) : (
    <></>
  );
};

export default NewSubscriberPromo;
